import React, { FC, useState } from 'react'
import styled from 'styled-components'

const StyledReorderTarget = styled.div<{ $isActive: boolean }>`
  height: 8px;
  position: relative;
  margin-top: -2px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 2px;
    background-color: ${({ $isActive }) =>
      $isActive ? '#4CAF50' : 'transparent'};
    transform: translateY(-50%);
    pointer-events: none;
  }
`

export const MarkupReorderTarget: FC<{
  onDrop: (data: string) => void
  dataKey: string
}> = ({ onDrop, dataKey }) => {
  const [isActive, setIsActive] = useState(false)

  const handleDragOver = (e: React.DragEvent) => {
    // Only handle if dragging the correct data type
    if (!e.dataTransfer.types.includes(dataKey.toLowerCase())) {
      return
    }

    e.preventDefault()
    e.stopPropagation()
    setIsActive(true)
  }

  const handleDragLeave = (e: React.DragEvent) => {
    e.preventDefault()
    e.stopPropagation()
    setIsActive(false)
  }

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault()
    e.stopPropagation()

    const data = e.dataTransfer.getData(dataKey)
    if (data) {
      onDrop(data)
    }

    setIsActive(false)
  }

  return (
    <StyledReorderTarget
      $isActive={isActive}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    />
  )
}
